module.exports = __webpack_public_path__ + "static/img/thumb-family-forest-lands.057d462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-family-forest-lands.png
// module id = 87
// module chunks = 0